'use client'

import { DUR, EASE } from '@/animations/settings/vars'
import { useGSAPContext } from '@/hooks'
import { cn } from '@/lib/utils'
import { useStoreNavigation } from '@/store'
import { Typo3Header } from '@/types/typo3'
import { Container } from '@/ui/components'
import { gsap } from '@gsap'
import { memo, useEffect, useEffectEvent, useRef, useState } from 'react'
import SearchInput from './SearchInput'

const Search = ({ data }: { data: Typo3Header['search'] }) => {
  const comp = useRef<HTMLDivElement>(null)
  const searchContainerRef = useRef<HTMLDivElement>(null!)
  const searchInputRef = useRef<HTMLInputElement>(null)
  const tl = useRef<GSAPTimeline | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const { isSearchModalOpen } = useStoreNavigation()

  useGSAPContext({
    scope: comp,
    callback() {
      if (!comp.current) {
        return
      }

      gsap.set('[data-search-container]', { y: '-100%' })

      tl.current = gsap
        .timeline({
          paused: true,
          defaults: { ease: EASE.out, duration: DUR.default }
        })
        .to('[data-search-container]', { y: 0, delay: 1 })
    }
  })

  useEffect(() => {
    if (isSearchModalOpen === true) {
      tl.current?.play()
      searchInputRef.current?.focus()
    } else {
      tl.current?.reverse()
      searchInputRef.current?.blur()
    }
  }, [isSearchModalOpen])

  const handleSetIsLoaded = useEffectEvent(() => {
    setIsLoaded(true)
  })

  useEffect(() => {
    handleSetIsLoaded()
  }, [])

  return (
    <div ref={comp}>
      <div
        className={cn(
          'fixed top-0 right-0 left-0 z-40 bg-neutral-100 pt-[calc(var(--spacing-sm)*2+var(--logo-header-height))]',
          !isLoaded && 'hidden'
        )}
        ref={searchContainerRef}
        data-search-container
      >
        <Container className="py-lg">
          <SearchInput
            data={data}
            ref={searchInputRef as React.RefObject<HTMLInputElement>}
          />
        </Container>
      </div>
    </div>
  )
}

export default memo(Search)
